import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'EB100 GmbH' }]

export default function Index() {
	return (
		<div>
			<div className="relative">
				<div className="mx-auto max-w-7xl">
					<div className="relative z-10 lg:w-full lg:max-w-2xl">
						<div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:hidden lg:w-1/2">
							<picture>
								<img
									sizes="(max-width: 1400px) 100vw, 1400px"
									srcSet="
								/img/hero_min_pi3cl3_c_scale_w_688.webp 688w,
								/img/hero_min_pi3cl3_c_scale_w_1001.webp 1001w,
								/img/hero_min_pi3cl3_c_scale_w_1210.webp 1210w,
								/img/hero_min_pi3cl3_c_scale_w_1400.webp 1400w"
									src="/img/hero_min_pi3cl3_c_scale_w_1400.webp"
									alt="Cityscape"
									className="absolute left-0 top-0 h-full w-full object-cover text-center opacity-5"
								/>
							</picture>
						</div>

						<svg
							className="absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2 transform fill-background lg:block"
							viewBox="0 0 100 100"
							preserveAspectRatio="none"
							aria-hidden="true"
						>
							<polygon points="0,0 90,0 50,100 0,100"></polygon>
						</svg>
						<div
							style={{
								animationName: 'fadeIn',
								animationDuration: '0.5s',
								animationTimingFunction: 'ease-in-out',
								animationFillMode: 'forwards',
							}}
						>
							<div
								className="relative px-6 py-32 sm:py-40 lg:px-8 lg:py-36 lg:pr-0"
								style={{
									animationName: 'slideRight',
									animationDuration: '0.5s',
									animationTimingFunction: 'ease-in-out',
									animationFillMode: 'forwards',
								}}
							>
								<div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
									<h1 className="sr-only">EB 100</h1>
									<div>
										<img
											src="/img/logo.png"
											alt="EB100 GmbH Logo"
											className="w-48 sm:w-60 md:w-80"
										/>
									</div>

									<div>
										<h1 className="text-4xl font-bold tracking-tight text-[#e4e4df] sm:text-6xl">
											Versatility in Action
										</h1>
										<p className="mt-6 pl-16 text-lg leading-8 text-[#cfd0cb]">
											Innovating Across Industries
										</p>
										<div className="mt-10 flex items-center gap-x-6">
											<Link
												to="#activities"
												className="rounded-md bg-[#cfd0cb] px-3.5 py-2.5 text-sm font-semibold text-background shadow-sm hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
											>
												Company activities
											</Link>
											<Link
												to="#footer"
												className="text-sm font-semibold leading-6 text-foreground underline decoration-white/25 underline-offset-4 hover:decoration-white"
											>
												Contact
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="hidden bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:block lg:w-1/2">
					<picture>
						<img
							sizes="(max-width: 1400px) 100vw, 1400px"
							srcSet="
                /img/hero_min_pi3cl3_c_scale_w_688.webp 688w,
                /img/hero_min_pi3cl3_c_scale_w_1001.webp 1001w,
                /img/hero_min_pi3cl3_c_scale_w_1210.webp 1210w,
                /img/hero_min_pi3cl3_c_scale_w_1400.webp 1400w"
							src="/img/hero_min_pi3cl3_c_scale_w_1400.webp"
							alt="Cityscape"
							className="aspect-[3/2] object-cover lg:aspect-auto lg:h-full lg:w-full"
						/>
					</picture>
				</div>
			</div>

			<main className="" id="activities">
				<div className="py-24 md:py-32 lg:py-40">
					<div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
						<div className="mx-auto max-w-2xl lg:mx-0">
							<h2 className="text-3xl font-bold tracking-tight text-[#e4e4df] sm:text-4xl">
								Company activities
							</h2>
							<p className="mt-6 text-lg leading-8 text-[#cfd0cb]">
								At EB100 GmbH, our diverse range of activities spans across
								various industries, reflecting our commitment to innovation and
								quality. We are engaged in a myriad of sectors including
								technology, hospitality, and travel. In each domain, we strive
								to deliver cutting-edge solutions and products that meet the
								evolving needs of our customers and society.
							</p>
						</div>
						<ul className="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:gap-x-8 xl:col-span-2">
							<li>
								<img
									src="/img/rpp.webp"
									alt="Square pizza and pizza ingredients on a table"
									className="aspect-[3/2] w-full rounded-2xl object-cover"
								/>
								<h3 className="mt-6 text-lg font-semibold leading-8 text-[#e4e4df]">
									Red Pepper Pizza
								</h3>
								<p className="text-base leading-7 text-[#cfd0cb]">
									Restaurant | London, UK
								</p>
								<p className="mt-4 text-base leading-7 text-[#cfd0cb]">
									Red Pepper Pizza is the heart of the community. Our beloved
									local pizzeria has become a culinary landmark, known for its
									mouth-watering, authentic pizzas. Our skilled pizza masters
									knead and toss the dough daily, ensuring every pizza has the
									perfect crust - crispy on the outside, soft on the inside. Our
									efficient takeout service ensures your food is always hot and
									ready when you are, whether you're grabbing a quick lunch or
									planning a family dinner. At Red Pepper Pizza, it's not just
									about serving food, but about creating a sense of community
									and making every meal a memorable experience.
								</p>
								{/* <div className="mt-4">
									<Link to="/activity/red-pepper-pizza" className="underline">
										Learn more
									</Link>
								</div> */}
							</li>
							<li>
								<img
									src="/img/tfts.webp"
									alt="Time for Travel logo with an airplane"
									className="aspect-[3/2] w-full rounded-2xl object-cover"
								/>
								<h3 className="mt-6 text-lg font-semibold leading-8 text-[#e4e4df]">
									Time for Travel
								</h3>
								<p className="text-base leading-7 text-[#cfd0cb]">
									Travel Agency | International
								</p>
								<p className="mt-4 text-base leading-7 text-[#cfd0cb]">
									Our travel agency has earned a reputation for excellence,
									specializing in creating tailor-made vacation experiences that
									cater to the unique desires of each traveler. From exotic
									beach getaways to cultural city tours, adventure treks to
									luxury cruises, our extensive network and expert knowledge
									ensure unforgettable journeys. We pride ourselves on our
									exceptional customer service, providing personalized support
									at every step of your journey. Our commitment to responsible
									and sustainable travel practices also means that with every
									trip we organize, we're not only creating lasting memories for
									our clients but also positively impacting the destinations we
									visit.
								</p>
								{/* <div className="mt-4">
									<Link to="/activity/red-pepper-pizza" className="underline">
										Learn more
									</Link>
								</div> */}
							</li>
							<li>
								<img
									src="/img/est.webp"
									alt="EST. for you logo"
									className="aspect-[3/2] w-full rounded-2xl object-cover"
								/>
								<h3 className="mt-6 text-lg font-semibold leading-8 text-[#e4e4df]">
									Property Management
								</h3>
								<p className="text-base leading-7 text-[#cfd0cb]">
									International
								</p>
								<p className="mt-4 text-base leading-7 text-[#cfd0cb]">
									As a property management company operating across Europe, we
									manage a diverse portfolio of rental properties. We specialize
									in renting out these properties and conduct thorough tenant
									screenings, handling all lease agreement details. Our team
									ensures regular maintenance and compliance with local housing
									regulations for each property. Financially, we manage rent
									collection, operating expenses, and provide detailed financial
									reports to property owners. Essentially, we bridge the gap
									between property owners and tenants, offering a hassle-free
									rental experience for both, allowing property owners to enjoy
									their investments' benefits and tenants to have a high-quality
									living experience.
								</p>
								{/* <div className="mt-4">
									<Link to="/activity/red-pepper-pizza" className="underline">
										Learn more
									</Link>
								</div> */}
							</li>
							<li>
								<img
									src="/img/abbey.webp"
									alt="Abbey DLD Group of Colleges. Cambridge, London, Manchester"
									className="aspect-[3/2] w-full rounded-2xl object-cover"
								/>
								<h3 className="mt-6 text-lg font-semibold leading-8 text-[#e4e4df]">
									International Students
								</h3>
								<p className="text-base leading-7 text-[#cfd0cb]">
									United Kingdom
								</p>
								<p className="mt-4 text-base leading-7 text-[#cfd0cb]">
									We specialize in placing international students into leading
									schools and universities across the UK. We provide
									comprehensive guidance and support throughout the entire
									application process, from selecting the right institution to
									preparing for entrance examinations and interviews. We also
									offer assistance with visa applications and accommodation
									arrangements, making the transition to studying in the UK as
									smooth as possible. Through our personalized approach, we help
									students navigate the complexities of applying to UK
									educational institutions, paving the way for their academic
									success and personal growth in a new educational environment.
								</p>
								{/* <div className="mt-4">
									<Link to="/activity/red-pepper-pizza" className="underline">
										Learn more
									</Link>
								</div> */}
							</li>
						</ul>
					</div>
				</div>
			</main>

			<footer id="footer" className="grid grid-cols-1 md:grid-cols-2">
				<div className="col-span-2 flex flex-col gap-5 bg-[#cfd0cb] p-6 py-16 text-gray-700 sm:col-span-1 lg:px-8 lg:py-24">
					<div className="mx-auto max-w-xl">
						<div className="divide-x-2 divide-[#252525]">
							<div />

							{/* eslint-disable-next-line remix-react-routes/use-link-for-routes */}
							<a href="tel:004915140001190" className="pl-2 sm:pl-4">
								+49 151 40001190
							</a>
						</div>

						<div className="divide-x-2 divide-[#252525] pt-5">
							<div />

							<div className="pl-2 sm:pl-4">
								<p>EB100 GmbH</p>
								<p>Speditionstraße 21</p>
								<p>Düsseldorf, 40221</p>
								<p>Germany</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-span-2 flex items-center justify-center bg-[#e4e4df] text-gray-700 sm:col-span-1">
					<img src="/img/qr-code.svg" alt="Contact QR code" className="w-48" />
				</div>
			</footer>
		</div>
	)
}
